import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t mt-auto py-6 text-center text-sm text-slate-500 bg-white">
      <div className="flex justify-center gap-4">
        <Link to="/privacy" className="hover:text-slate-700">Privacy Policy</Link>
        <span>·</span>
        <Link to="/terms" className="hover:text-slate-700">Terms of Service</Link>
        <span>·</span>
        <a 
          href="mailto:cs@instructing.com" 
          className="hover:text-slate-700 cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = 'mailto:cs@instructing.com';
          }}
        >
          Contact
        </a>
      </div>
      <p className="mt-2">© 2026 Instructing.com LLC. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
